module.exports = __webpack_public_path__ + "assets/img/u5e7070dda030b.9716dc05.png";